import { InjectionToken } from '@angular/core';

/**
 * Shared SSR tokens for server-side rendering context.
 * Use these tokens to inject the request and response objects in Angular Universal/Nx SSR setups.
 */
export const REQUEST = new InjectionToken<IRequest>('REQUEST');
export const RESPONSE = new InjectionToken<unknown>('RESPONSE');
export const SSR_REQUEST = new InjectionToken<Request>('SSR_REQUEST');
export const SSR_RESPONSE = new InjectionToken<Response>('SSR_RESPONSE');

/**
 * AbortSignal for SSR renders. When a render times out, this signal is aborted
 * to allow in-flight HTTP requests to be cancelled and cleanup to proceed.
 */
export const SSR_ABORT_SIGNAL = new InjectionToken<AbortSignal>('SSR_ABORT_SIGNAL');

export interface IRequest {
  headers: {
    cookie: string;
  };
}
